module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/4RySAg/tc-custom/9781508082217.jpg?1705766092476",
      "alt": "This image is the cover for the book Garden at the Edge of Beyond, The Beyond Trilogy"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Garden at the Edge of Beyond, The Beyond Trilogy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A journey into a realm beyond imagination gives one man a glimpse into his own spirituality through messages of faith, hope, and love. ")]), _c('br'), _c('br'), _vm._v("A man lies down for a normal night of sleep and inexplicably awakens to find himself in a surreal garden bursting with fantastic aromas and colors."), _c('br'), _c('br'), _vm._v("A succession of “tour guides’ come and go, helping him to interpret the landscape’s fragrant messages, each one a clue on the journey to discover his true self, and, ultimately, the Creator of the Country Beyond."), _c('br'), _c('br'), _c('b', [_vm._v("“One night, a 48-year-old man undergoes a truly odd experience. He awakens in a strange world, where he is able to discuss theology with such entities as a Scotsman and an Englishman, meant to be the well-known Christian theologians George MacDonald and C.S. Lewis . . . Phillips brings off this unexpected premise surprisingly well . . . a wonderful starting point for some great debate.” —"), _c('i', [_vm._v("Library Journal")])])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Michael Phillips\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Bondfire Books LLC\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0